<footer class="footer ">
    <div class="footer-content">      
       <p><small>Secretaría Distrital de Salud - versión 1.0.0.0 - {{ fecha }} ({{ title }})</small> </p>
    </div>
</footer>